import { fetchService } from './fetchService';

export const signUpService = {
    signUp,activate,emailAvailable
};

const baseUrl = (document.Rintagi || {}).apiBasename + "/webservices";
const fetchAPIResult = fetchService.fetchAPIResult;
const getAPIResult = fetchService.getAPIResult;

async function emailAvailable(emailAddress) {
    return fetchAPIResult(baseUrl+"/SignUpWs.asmx/EmailAvailable"
    ,{
        requestOptions: {
            body:JSON.stringify({
                emailAddress:emailAddress || "",
            })
        }
    })
    .then(
    async result=>{
        if (result.status === "success" && result.data.value.d && result.data.value.d.status === "success") {
            return {
                data: getAPIResult(result).data,
            }
        }
        else {
            return Promise.reject( {
                status : "failed",
                errType: result.status === "success" ? "api call error" : result.errType,
                errSubType: result.errSubType || result.data.value.d.error,
                errMsg : result.status === "success" ? result.data.value.d.message || result.data.value.d.errorMsg : result.errType
            })
        }
    },
    error=>{
        return Promise.reject(error);
    }
    )

}

async function signUp(emailAddress, reCaptchaRequest, refCode) {
    return fetchAPIResult(baseUrl+"/SignUpWs.asmx/SignUp"
    ,{
        requestOptions: {
            body:JSON.stringify({
                emailAddress:emailAddress || "",
                reCaptchaRequest: reCaptchaRequest || "",
                refCode:refCode || "",
            })
        }
    })
    .then(
    async result=>{
        if (result.status === "success" && result.data.value.d && result.data.value.d.status === "success") {
            return {
                data: getAPIResult(result).data,
            }
        }
        else {
            console.log(result);
            return Promise.reject( {
                status : "failed",
                errType: result.status === "success" ? "api call error" : result.errType,
                errSubType: result.errSubType || result.data.value.d.error,
                errMsg : result.status === "success" ? result.data.value.d.message || result.data.value.d.errorMsg : result.errType
            })
        }
    },
    error=>{
        return Promise.reject(error);
    }
    )

}

function activate(fullName, emailAddress, password, role, nounce, ticketLeft, ticketRight, refCode) {
    return fetchAPIResult(baseUrl+"/SignUpWs.asmx/Activate"
    ,{
        requestOptions: {
            body:JSON.stringify({
                fullName: fullName || "",
                emailAddress:emailAddress || "",
                password: password || "",
                role:role || "",
                nounce: nounce || "",
                ticketLeft:ticketLeft || "",
                ticketRight: ticketRight || "",
                refCode: refCode || "",
            })
        }
    })
    .then(
    async result=>{
        if (result.status === "success" && result.data.value.d && result.data.value.d.status === "success") {
            return {
                data: getAPIResult(result).data,
            }
        }
        else {
            console.log(result);
            return Promise.reject( {
                status : "failed",
                errType: result.status === "success" ? "api call error" : result.errType,
                errSubType: result.errSubType || result.data.value.d.error,
                errMsg : result.status === "success" ? result.data.value.d.message : result.errType
            })
        }
    },
    error=>{
        return Promise.reject(error);
    }
    )
}


// WEBPACK FOOTER //
// ./src/services/signUpService.js